export const STORE_COMPETITORS = 'competitors';
export const COM_SET_DEFAULT_FILTERS = 'setDefaultFilters';
export const COM_SET_DEFAULT_SIMPLE_FILTERS = 'setDefaultSimpleFilters';
export const COM_SET_DEFAULT_ADVANCED_FILTERS = 'setDefaultAdvancedFilters';
export const COM_GET_COMPETITORS_DATA = 'getCompetitorsData';
export const COM_UPDATE_FILTERS = 'updateFilters';
export const COM_UPDATE_COMPETITOR_SETTINGS = 'updateCompetitorSettings';
export const COM_START_IMPORT = 'startImport';
export const COM_STOP_IMPORT = 'stopImport';
export const COM_FETCH_CURRENT_HOLIDAYS = 'fetchCurrentHolidays';
export const COM_FETCH_DAILY_PRICES = 'fetchDailyPrices';
export const COM_GET_OTA_MONTHLY_PRICES = 'getOtaMonthlyPrices';
export const COM_GET_OTA_PRICE_COMPARISON = 'getOtaPriceComparison';
export const COM_GET_CHART_FOR_DATE = 'getChartDataForDate';

export const COM_CREATE_SET = 'createSet';
export const COM_UPDATE_SET = 'updateSet';
export const COM_DELETE_SET = 'deleteSet';

export const COM_GET_BED_TYPES = 'getBedTypeCompetitors';
export const COM_UPDATE_BED_TYPES = 'updateBedTypes';
export const COM_CREATE_USER_BED_TYPE = 'createUserBedType';
export const COM_UPDATE_USER_BED_TYPE = 'updateUserBedType';
export const COM_DESTROY_USER_BED_TYPE = 'destroyUserBedType';

export const COM_DEFAULT_CALC_TYPE = 'min';
export const COM_MAX_SETS = 5;
export const COM_MAX_KEYWORDS = 20;
export const COM_KEYWORD_SEPARATORS = /, |,|、| |　/;

export const COM_DEFAULT_GUEST_COUNT = 2;

export const COM_DEFAULT_SIMPLE_FILTERS = {
  calculation_type: COM_DEFAULT_CALC_TYPE,
  competitor_groups: [],
  selected_group: null,
  otas: [],
  guest_count: COM_DEFAULT_GUEST_COUNT,
};

export const COM_DEFAULT_ADVANCED_FILTERS = {
  bed_types: [],
  user_bed_types: [],
  is_multiple: false,
  room_types: [],
  meal: null,
  quo_card: null,
  smoking: null,
  vod: null,
  included_keywords: '',
  excluded_keywords: '',
  price_source: 'per_room',
  price_tax: 'with_taxes',
  sold: 'on',
};

export const DEFAULT_INVENTORY_FILTERS = {
  competitor_groups: [],
  selected_group: null,
  otas: null,
};

// export const COM_DEFAULT_SORT_OTAS = [1, 2, 0, 6];
